import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { obterComentarioCampoDemanda, salvarComentarioCampo } from '@app/api/demanda';
import { Button, Icon } from '@digital/ui';
import ListMensagem from './ListMensagem';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalComentario {
  idDoComponente: string;
  campoId: string;
  demandaId: string;
  preSuprimentos: boolean | undefined;
  disabled?: boolean;
  ehTelaDemandante?: boolean;
  existeComentario?: (contem: boolean) => void;
}

const ModalComentariosCampoDemanda = (props: PropsModalComentario) => {
  const { campoId, preSuprimentos, demandaId, disabled, ehTelaDemandante, existeComentario, idDoComponente } = props;
  const [recarregarMensagem, setRecarregarMensagem] = useState(false);
  const [exibirModal, setExibirModal] = useState(false);
  const [iconeComentario, setIconeComentario] = useState('');
  const [contemComentario, setContemComentario] = useState(false);
  const [mensagens, setMensagens] = useState([]);


  const limparCampo = () => {
    let elemento = document.getElementById(idDoComponente) as any;
    if (elemento) {
      elemento.value = '';
    }
  };

  const getAll = async () => {
    setRecarregarMensagem(!recarregarMensagem);
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    let elemento = document.getElementById(idDoComponente) as any;
    const text = elemento.value;
    const form = new FormData();
    form.append('campoId', campoId);
    form.append('demandaId', demandaId);
    form.append('mensagem', text);
    form.append('preSuprimentos', preSuprimentos ? '1' : '0');

    salvarComentarioCampo(form).then((data: any) => {
      if (data && data.valid) {
        limparCampo();
        setRecarregarMensagem(!recarregarMensagem);
      }
    });
  };

  useEffect(() => {
    if (campoId) {
      obterComentarioCampoDemanda(campoId, demandaId).then((data: any) => {
        if (data) {
          if (data.length > 0) {
            setContemComentario(true);
            existeComentario && existeComentario(true);
          }
          setMensagens(data);
        }
      });
    }
  }, [campoId, recarregarMensagem]);

  return (
    <>
      {ehTelaDemandante && !contemComentario ? (
        <></>
      ) : (
        <Tooltip
          key={campoId}
          title="Comentários">
          <Button
            type='link'
            onClick={
              () => {
                getAll();
                showModal();
              }
            }
            icon="messaging-comments"
            className={contemComentario ? 'has-comments' : ''}
            disabled={disabled}
            id={`mrn-button-modal-ModalComentariosCampoDemanda-${idDoComponente}`}
          />
        </Tooltip>
      )}

      {exibirModal && (
        <Modal
          title="Comentário"
          className="chat-modal"
          visible={exibirModal}
          onCancel={() => {
            handleCancel();
          }}
          footer={[
            <Button
              id={`mrn-button-modal-ModalComentariosCampoDemanda-fechar-${idDoComponente}`}
              type="link" onClick={() => handleCancel()}>
              Fechar
            </Button>,
            <Button
              id={`mrn-button-modal-ModalComentariosCampoDemanda-enviar-${idDoComponente}`}
              key="submit" type="primary" onClick={e => Salvar(e)}>
              Enviar
            </Button>,
          ]}>
          {campoId && <ListMensagem mensagens={mensagens} />}
          <div className="chat-modal-message-box">
            <Form>
              <Form.Item>
                <TextArea id={idDoComponente} placeholder="mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={300} />
              </Form.Item>
            </Form>
          </div>
        </Modal>
      )}

    </>
  );
};

export default ModalComentariosCampoDemanda;
